// Add your custom JS here.
import $ from 'jquery';

import './custom/cmx';
import './custom/sliders';
import './custom/users';
import LocomotiveScroll from 'locomotive-scroll';
const locomotiveScroll = new LocomotiveScroll();



jQuery(document).ready(function($){

    let removedDateCols = [];

    $('.grid-view').on('click', function(){

        // Button states
        $('.list-view').removeClass('active');
        $(this).addClass('active');

        $('.stripe.games-stripe').addClass('grid-view');
        $('.month-label').parent().removeClass('text-center');

        // Remove date-marker columns and remember position
        removedDateCols = [];

        $('.date-marker').each(function(){

            const parentCol = $(this).closest('.col-12');
            const nextEl = parentCol.next(); // remember what was after it

            removedDateCols.push({
                col: parentCol.detach(),
                next: nextEl
            });

        });

        // Remove game-item class (as you want)
        $('.col-6.col-md-3').removeClass('game-item');

    });


    $('.list-view').on('click', function(){

        // Button states
        $('.grid-view').removeClass('active');
        $(this).addClass('active');

        $('.stripe.games-stripe').removeClass('grid-view');
        $('.month-label').parent().addClass('text-center');

        // Restore date-marker columns in original spots
        removedDateCols.forEach(function(item){

            if (item.next.length) {
                item.col.insertBefore(item.next);
            } else {
                // fallback: append to parent row
                item.col.appendTo(item.col.closest('.row'));
            }

        });

        // Clear memory
        removedDateCols = [];

        // Back to list layout (if needed)
        $('.col-6.col-md-3').addClass('game-item');

    });

});



(function () {

	const html = document.documentElement;
	const themeBtn = document.getElementById('bd-theme');
	const themeIcon = document.getElementById('theme-icon');

	// Load saved theme or system preference
	let savedTheme = localStorage.getItem('theme');

	if (!savedTheme) {
		savedTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
			? 'dark'
			: 'light';
	}

	setTheme(savedTheme);

	// Toggle on click
	themeBtn.addEventListener('click', () => {

		const currentTheme = html.getAttribute('data-bs-theme');
		const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

		setTheme(newTheme);

	});

	function setTheme(theme) {

		// Set Bootstrap theme
		html.setAttribute('data-bs-theme', theme);

		// Save
		localStorage.setItem('theme', theme);

		// Update icon
		if (theme === 'dark') {
			themeIcon.classList.remove('fa-sun');
			themeIcon.classList.add('fa-moon');
		} else {
			themeIcon.classList.remove('fa-moon');
			themeIcon.classList.add('fa-sun');
		}
	}

})();

$(document).ready(function() {

    // Navbar scroll
    var navbar = $('.navbar');
    var offset = navbar.offset().top;

    $(window).on('scroll', function() {
        if ($(window).scrollTop() > offset) {
        navbar.addClass('sticky-top');
        } else {
        navbar.removeClass('sticky-top');
        }
    });

    $('#confirmDeleteYes').on('click', function() {
		$('#deleteAccountForm').trigger('submit');
	});
});

// Delete Games
$(document).ready(function() {
    var actionUrl = '';

    // Function to show alert.
    function showAlert(message, type = "success") {
        const alertBox = $("#action-alert");
        alertBox
            .removeClass("d-none alert-success alert-danger alert-warning")
            .addClass("alert-" + type)
            .html(`
                ${message}
               
            `);

        // Close button
        alertBox.find(".btn-close").on("click", function () {
            alertBox.addClass("d-none");
        });

        // Auto-hide after 8s
        setTimeout(() => {
            alertBox.addClass("d-none");
        }, 8000);
    }

    // Handle modal click.
    $('.confirm-action').on('click', function(e) {
        e.preventDefault();

        actionUrl = $(this).data('action-url');
        const actionType = $(this).data('action-text').toLowerCase();

        // Set modal title dynamically
        let modalTitle = 'Confirm Action';
        if(actionType === 'publish') modalTitle = 'Confirm Publish';
        else if(actionType === 'draft') modalTitle = 'Confirm Draft';
        else if(actionType === 'delete') modalTitle = 'Confirm Deletion';
        $('#confirmActionLabel').text(modalTitle);

        // Set modal body text
        $('#confirmActionTextDocs').text('Are you sure you want to ' + actionType + ' this game?');

        // Set button styles
        $('#confirmActionYes')
            .removeClass('btn-primary btn-success btn-warning btn-danger')
            .addClass('btn-primary');

        $('#confirmActionNo')
            .removeClass('btn-secondary btn-outline-secondary btn-tertiary btn-outline')
            .addClass('btn-tertiary btn-outline');
    });

    // When "Yes" clicked, go to URL
    $('#confirmActionYes').on('click', function() {
        if(actionUrl) {
            window.location.href = actionUrl;
        }
    });

    // Show alert if URL has message parameter
    const urlParams = new URLSearchParams(window.location.search);
    const message = urlParams.get('message');

    if(message) {
        let alertMessage = '';
        let alertType = 'success';

        if(message === 'drafted') alertMessage = 'Game saved as draft!';
        else if(message === 'published') alertMessage = 'Game published successfully!';
        else if(message === 'deleted') alertMessage = 'Game deleted successfully!';

        if(alertMessage) {
            showAlert(alertMessage, alertType);
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }
});

$(document).ready(function(){
    $('.tip').hover(
        function() {
            $(this).find('.tooltip-text').fadeIn(200);
        },
        function() {
            $(this).find('.tooltip-text').fadeOut(200);
        }
    );
});

$(document).ready(
    function () {

        $('.profile-form').on(
            'submit', function (e) {
                var password = $('input[name="password"]').val().trim();
                var confirmPassword = $('input[name="confirm_password"]').val().trim();

                // Remove previous alerts
                $('.profile-form + .alert').remove();

                if (!password || !confirmPassword) {
                      e.preventDefault();
                      var alertDiv = $('<div class="alert alert-danger mt-3">Please fill in both password fields.</div>');
                      $(this).after(alertDiv);
                      return;
                }

                if (password !== confirmPassword) {
                    e.preventDefault();
                    var alertDiv = $('<div class="alert alert-danger mt-3">Passwords do not match!</div>');
                    $(this).after(alertDiv);
                }
            }
        );

        // Check the cookie
        const isClosed = document.cookie
        .split('; ')
        .find(row => row.startsWith('metaListClosed='));

        // If cookie exists and is true, hide the list and add closed class
        if (isClosed && isClosed.split('=')[1] === 'true') {
            $('.meta-list ul').hide();
            $('.meta-list .title i').addClass('closed');
        }

        // Click event
        $('.meta-list .title i').on(
            'click', function () {
                const isCurrentlyClosed = $(this).hasClass('closed');

                // Toggle visibility and class
                $('.meta-list ul').slideToggle();
                $(this).toggleClass('closed');

                // Set cookie based on new state
                document.cookie = `metaListClosed=${!isCurrentlyClosed}; path=/`;
            }
        );
    }
);



$(document).ready(
    function () { 



        //Click event to scroll to topxx
        $('.scroll-to-top').click(
            function () {
                $('html, body').animate({scrollTop : 0},800);
                return false;
            }
        );


        //CMX Stripe Colour 
        $('.click-cmx').click(
            function () {
                location.href = "?cmx=1";
                return false;
            }
        );

        if(window.location.href.indexOf("?cmx=1") != -1) {
            $('.click-cmx').addClass("d-none");
        }

        //Check to see if the window is top if not then display button
        $(window).scroll(
            function () {
                if ($(this).scrollTop() > 500) {
                    $('.scroll-to-top').fadeIn();
                } else {
                      $('.scroll-to-top').fadeOut();
                }
            }
        );

        //console.log('test1');

        $(".navbar-toggler").on(
            "click", function (e) {
                $(this).toggleClass("opened");
                $("body").css('padding-right', '0');
                $('.offcanvas').css('visibility', 'visible');
            }
        );

        $(".offcanvas-backdrop").on(
            "click", function (e) {
                $(".navbar-toggler").removeClass("opened");
                $("body").css('padding-right', '0');
            }
        );


        $('.sub-menu-toggle').on(
            'click', function () {
                $(this).toggleClass('show');
                $(this).parent().find('.dropdown-menu').first().slideToggle();
            }
        )
      
        $('a.nav-link.dropdown-toggle').click(
            function () {
                location.href = this.href;
            }
        );

    }
);

// Light & Dark Mode

$(document).ready(function () {

	const $themeButtons = $('[data-bs-theme-value]');
	const $html = $('html');
	const $themeIcon = $('#theme-icon');

	// Load saved theme or fallback to current attribute
	let savedTheme = localStorage.getItem('theme') || $html.attr('data-bs-theme') || 'light';

	setTheme(savedTheme);

	$themeButtons.on('click', function () {
		const theme = $(this).data('bs-theme-value');
		setTheme(theme);
	});

	function setTheme(theme) {

		// Set html attribute
		$html.attr('data-bs-theme', theme);

		// Save preference
		localStorage.setItem('theme', theme);

		// Update active + aria
		$themeButtons
			.removeClass('active')
			.attr('aria-pressed', 'false');

		const $activeBtn = $(`[data-bs-theme-value="${theme}"]`);

		$activeBtn
			.addClass('active')
			.attr('aria-pressed', 'true');

		// Update icon
		if (theme === 'dark') {
			$themeIcon.removeClass('fa-sun').addClass('fa-moon');
		} else {
			$themeIcon.removeClass('fa-moon').addClass('fa-sun');
		}
	}

});


var myOffcanvas = document.getElementById('navbarNavOffcanvas')
myOffcanvas.addEventListener(
    'hidden.bs.offcanvas', function () {
        var navbar = document.querySelector('.navbar-toggler');
        navbar.classList.remove("opened") 
    }
)
